import React, { useEffect, useState } from "react";
import { useForm } from "@formspree/react";
import useLocoScroll from "../hooks/useLocoScroll";
import { Link, useLocation } from "react-router-dom";
import { ImMap2 } from "react-icons/im";
import { AiOutlinePhone } from "react-icons/ai";
import { VscMail } from "react-icons/vsc";
import SocialItem from "../components/Social_item";
import { Footer } from "../components/Components";

const ContactInfo = ({ icon, text }) => {
  return (
    <div className="info mb-2">
      <div className="icon">{icon}</div>
      <p className="p-text text">{text}</p>
    </div>
  );
};

const Contact = () => {
  const Location = useLocation();
  const [preloader, setPreloader] = useState(true);
  const preload = () => {
    setPreloader(false);
  };
  const scrollRef = useLocoScroll(!preloader);

  useEffect(() => {
    const timer = setTimeout(() => {
      preload();
    }, 500);
    return () => clearTimeout(timer);
  }, [Location]);

  const [state, handleSubmit] = useForm("xayvnwgn");
  if (state.succeeded) {
    return (
      <>
        <div className="submit">
          <h2>thanks for messaging !</h2>
          <button className="btn">
            <Link to="/" className="submit__btn">
              back to home
            </Link>
          </button>
        </div>
      </>
    );
  }

  return (
    <>
      <div ref={scrollRef}>
        <div className="contact">
          <div className="row">
            <h1 className="heading">get in touch</h1>
            <div className="contact__columns">
              <div className="contact__info">
                <h3 className="heading">don't be shy!</h3>
                <p className="p-text">
                  Feel free to get in touch with me. I am always open to
                  discussing new projects, creative ideas or opportunities to be
                  part of your visions.
                </p>
                <div>
                  <ContactInfo
                    icon={<ImMap2 />}
                    text="New Ailpara, Narayanganj, Dhaka, Bangladesh"
                  />
                  <ContactInfo
                    icon={<AiOutlinePhone />}
                    text={<a href="tel:01764469753">01764469753</a>}
                  />
                  <ContactInfo
                    icon={<VscMail />}
                    text={
                      <a href="mailto:mmaruf1137@gmail.com">
                        mmaruf1137@gmail.com
                      </a>
                    }
                  />
                </div>

                <SocialItem />
              </div>
              <form action="" className="contact__form" onSubmit={handleSubmit}>
                <div className="first-col">
                  <input
                    type="text"
                    name="name"
                    placeholder="your name"
                    className="input input-name"
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="your email"
                    className="input input-email lowercase"
                    required
                  />
                </div>
                <textarea
                  name="message"
                  className="input input-message"
                  placeholder="your message"
                  rows="12"
                ></textarea>
                <button className="btn">submit</button>
              </form>
            </div>
          </div>
          {/* <NaxtPage text="home" link="/" /> */}
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Contact;
